import { Component, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { SubSink } from "subsink";
import { SharedDataService } from "../../../shared/sharedData.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { Subject } from "rxjs";
import { ModalCreateTemplateComponent } from "../create-template/modal-create-template.component";
import {
    EmitEvent,
    EventBusService,
} from "../../../core/services/event-bus.service";

@Component({
    selector: "tpm-template-layout",
    templateUrl: "./template-layout.component.html",
    standalone: false
})
export class TemplateLayoutComponent implements OnInit, OnDestroy {
    constructor(
        private _modalService: BsModalService,
        private _sharedDataService: SharedDataService,
        private _eventBus: EventBusService,
        private log: NbcLoggerService
    ) {}

    buAccess: any;
    public onSync!: Subject<any>;
    sub = new SubSink();

    openCreateTemplateModal() {
        let bsModalRef: BsModalRef;
        const initialState: any = {
            userBuAccess: this.buAccess,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };
        bsModalRef = this._modalService.show(
            ModalCreateTemplateComponent,
            modalOptions
        );
        bsModalRef.content.onSync.subscribe((result) => {
            this._eventBus.emit(
                new EmitEvent("CreateTemplateModal", "searchTemplates", null)
            );
        });
    }

    ngOnInit() {
        this.sub.sink = this._sharedDataService
            .getBuAccess()
            .subscribe((data) => {
                this.buAccess = data;
            });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
